import { combineReducers } from "redux";
import {createItemReducer, createItemReducerParams} from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function annualRemunerationReducer() {
    return combineReducers({
        SalaryChangeData_ListForBossPO: createItemReducer("ReceiveSysDoc", "SalaryChangeData.ListBPO", false),
        SalaryChangeData_ListForBossPOParams: createItemReducerParams("ReceiveSysDoc", "SalaryChangeData.ListBPO"),

        SalaryChangeData_ListForBossPO_HistVac: createItemReducer("ReceiveSysDoc", "SalaryChangeData.ListBPO_HistVac", false),

        SalaryChangeData_ListForBossPO_Log: createItemReducer("ReceiveSysDoc", "SalaryChangeData.ListBPO_Log", false),

        SalaryChangeFixPers_ListForLog: createItemReducer("ReceiveSysDoc", "SalaryChangeFixPers.ListForLog", false),

        SalaryChangeData_ListForBossPO_YB_2020: createItemReducer("ReceiveSysDoc", "SalaryChangeData.ListBPO_YB_2020", false),

        SalaryChangeData_ListForBossPO_YBMF_2020: createItemReducer("ReceiveSysDoc", "SalaryChangeData.ListBPO_YBMF_2020", false),
        SalaryChangeData_ListForBossPO_YBMF_2020Params: createItemReducer("ReceiveSysDoc", "SalaryChangeData.ListBPO_YBMF_2020", true),

        SalaryChangeData_ListForBossPO_Props: createItemReducer("ReceiveSysDoc", "SalaryChangeData.ListBPO_Props", false),

        SalaryChangeData_ListBPO_Fix: createItemReducer("ReceiveSysDoc", "SalaryChangeData.ListBPO_Fix", false)
    });
}